import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";

interface SelectAllCheckboxProps {
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

const SelectAllCheckbox: React.FC<SelectAllCheckboxProps> = function (props) {
    const { style, children } = props;
    const orderManagementStore = useOrderManagementStore();
    const { disabled, checked } = orderManagementStore.table.selectAllStatus;

    const onSelectAllCheckboxChange = useCallback((e: CheckboxChangeEvent) => {
        const checked = e.target.checked;

        if (checked) {
            orderManagementStore.table.selectAllOrders();
        } else {
            orderManagementStore.table.unselectAllOrders();
        }
    }, []);

    return (
        <Checkbox
            className="order-table-select-all-order-checkbox"
            checked={checked}
            onChange={onSelectAllCheckboxChange}
            disabled={disabled}
            style={style}
        >
            {children}
        </Checkbox>
    );
};

export default observer(SelectAllCheckbox);
